/* eslint-disable no-console */

import { register } from 'register-service-worker';
import store from './store/app-store';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    registrationOptions: { scope: '/' },
    ready(registration) {
      const state = store.state as any;
      if (state.application.debugMode) {
        console.log(
          'App is being served from cache by a service worker.\n For more details, visit https://goo.gl/AFskqB'
        );
      }
      try {
        registration.update();
      } catch (err) {
        console.log(err);
      }
      setInterval(() => {
        try {
          console.log('Checking for update...');
          registration.update();
        } catch (err) {
          console.log(err);
        }
      }, 60000 * 2); // check for updates every 2 minutes.
    },
    registered() {
      const state = store.state as any;
      if (state.application.debugMode) {
        console.log('Service worker has been registered.');
      }
    },
    cached(reg) {
      const state = store.state as any;
      if (state.application.debugMode) {
        console.log(reg);
        console.log('Content has been cached for offline use.');
      }
    },
    updatefound() {
      const state = store.state as any;
      if (state.application.debugMode) {
        console.log('New content is downloading.');
      }
    },
    updated(registration) {
      const state = store.state as any;
      if (state.application.debugMode) {
        console.log('New content is available; please refresh.');
      }
      if (!state.application.appIsInitialized) {
        // if app init is not finished, update and install the new service worker (will reload the page.)
        document.dispatchEvent(
          new CustomEvent('swUpdated', {
            detail: { registration, hardRefresh: true },
          })
        );
      } else {
        document.dispatchEvent(
          new CustomEvent('swUpdated', {
            detail: { registration, hardRefresh: false },
          })
        );
      }
    },
    offline() {
      const state = store.state as any;
      if (state.application.debugMode) {
        console.log('No internet connection found. App is running in offline mode.');
      }
    },
    error(error) {
      const state = store.state as any;
      if (state.application.debugMode) {
        console.error('Error during service worker registration:', error);
      }
    },
  });
}
